const colors = ["#EF9A9A","#F48FB1","#CE93D8","#B39DDB","#9FA8DA","#90CAF9","#80DEEA","#80CBC4","#A5D6A7","#C5E1A5","#FFE082","#FFAB91","#BCAAA4","#EEEEEE","#B0BEC5"];

export const computeColors = (index) => colors[index%colors.length];